import styled from '@emotion/styled';
import themeUtils from '../../lib/themeUtils';

const Section = styled.section`
  padding-top: ${themeUtils.spacings.xl};
  padding-bottom: ${themeUtils.spacings.xl};
`;

export default Section;
